export function getView(stage, is_first) {
  return stage?.trim().length && is_first
}
